import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setTime, toggleTimerPaused, resetTimer,
} from 'redux/slices';
import { Box, Button, Typography } from '@mui/material';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

export function Counter() {
  const { gameStarted, time, timerPaused } = useSelector((state) => state.game);
  const dispatch = useDispatch();
  const timeRef = useRef(time);

  useEffect(() => {
    timeRef.current = time;
  }, [time]);

  useEffect(() => {
    let timer;
    if (gameStarted && !timerPaused) {
      timer = setInterval(() => {
        const { seconds, minutes } = timeRef.current;
        if (seconds < 59) {
          dispatch(setTime({ ...timeRef.current, seconds: seconds + 1 }));
        } else {
          dispatch(setTime({ minutes: minutes + 1, seconds: 0 }));
        }
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [gameStarted, timerPaused, dispatch]);

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2,
    }}
    >
      <Typography variant="h4" textAlign="center">
        {`${time.minutes}m:${time.seconds < 10 ? '0' : ''}${time.seconds}s`}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <Button
          size="small"
          variant="outlined"
          color="secondary"
          startIcon={timerPaused ? <PlayArrowIcon /> : <PauseIcon />}
          onClick={() => dispatch(toggleTimerPaused())}
        >
          {timerPaused ? 'Retomar' : 'Pausar'}
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="warning"
          startIcon={<RestartAltIcon />}
          onClick={() => dispatch(resetTimer())}
        >
          Zerar cronômetro
        </Button>
      </Box>
    </Box>
  );
}
